import { Alert, styled } from "@mui/material";
import {
  IconAlertCircle,
  IconCircleCheck,
  IconInfoCircle,
  IconPlaystationX
} from "@tabler/icons-react";

interface MxDisclaimerProps {
  variant: "warning" | "info" | "error" | "success";
  message: string;
}

const MxDisclaimer = (props: MxDisclaimerProps) => {
  const type = v[props.variant];
  return (
    <CustomAlert icon={type.icon} severity={type.color as any}>
      {props.message}
    </CustomAlert>
  );
};

export default MxDisclaimer;

const CustomAlert = styled(Alert)(({ theme }) => ({
  padding: theme.spacing(0.2, 2),
  borderRadius: 5,
  ".MuiAlert-message": {
    padding: 0,
    fontSize: theme.typography.caption.fontSize
  },
  ".MuiAlert-icon": {
    padding: 0,
    marginRight: 4,
    marginTop: 1,
    svg: {
      width: 17,
      height: 17
    }
  }
}));

const v = {
  warning: {
    icon: <IconAlertCircle />,
    color: "warning"
  },
  info: {
    icon: <IconInfoCircle />,
    color: "info"
  },
  error: {
    icon: <IconPlaystationX />,
    color: "error"
  },
  success: {
    icon: <IconCircleCheck />,
    color: "success"
  }
};
